import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import userPrefs from "./plugins/userPrefs";
import sanitize from "./plugins/sanitize";
import chartHelper from "./plugins/chartHelper";
import api from "./plugins/api";
import formatNumber from "./plugins/formatNumber";
import timezones from "./plugins/timezones";
import formValidation from "./plugins/formValidation";
import formatDateObject from "./plugins/formatDateObject";
import secondaryNavItems from "./plugins/secondaryNavItems";
import reportTypes from "./plugins/reportTypes";
import primaryNavItems from "./plugins/primaryNavItems";
import locationTypes from "./plugins/locationTypes";
import getAccountShortName from "./plugins/getAccountShortName";
import formatShortDomain from "./plugins/formatShortDomain";
import jsonToCsv from "./plugins/jsonToCsv";
import Vuelidate from "vuelidate";
import Hotjar from "vue-hotjar";
import Vuetify, { VDataTable } from "vuetify/lib";
import Skeleton from "vue-loading-skeleton";
import thqComponentLibrary from "@hitfoyb/thq-component-library/dist/thqComponentLibrary.umd";
import {
  mdiCheckboxBlankOutline,
  mdiCheckboxMarked,
  mdiMinusBox,
  mdiChevronRight,
  mdiChevronLeft,
} from "@mdi/js";

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

import "@hitfoyb/thq-component-library/dist/thqComponentLibrary.css";
import "@/scss/styles.scss";

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(userPrefs);
Vue.use(chartHelper);
Vue.use(api);
Vue.use(formatNumber);
Vue.use(timezones);
Vue.use(Vuelidate);
Vue.use(formValidation);
Vue.use(formatDateObject);
Vue.use(secondaryNavItems);
Vue.use(primaryNavItems);
Vue.use(reportTypes);
Vue.use(locationTypes);
Vue.use(getAccountShortName);
Vue.use(jsonToCsv);
Vue.use(thqComponentLibrary);
Vue.use(formatShortDomain);
Vue.use(sanitize);
Vue.use(Skeleton);
Vue.use(Vuetify, {
  components: { VDataTable },
});

const opts = {
  icons: {
    iconfont: "mdiSvg",
    defaultAssets: false,
    values: {
      checkboxOn: mdiCheckboxMarked,
      checkboxOff: mdiCheckboxBlankOutline,
      checkboxIndeterminate: mdiMinusBox,
      chevronRight: mdiChevronRight,
      chevronLeft: mdiChevronLeft,
    },
  },
};

const vuetify = new Vuetify(opts);

Vue.directive("focus-input", {
  inserted: function (el) {
    el.focus();
  },
});

Vue.use(Hotjar, {
  id: process.env.VUE_APP_HOTJAR_ID,
  isProduction: process.env.NODE_ENV === "production",
});

Vue.config.productionTip = false;

/*
 * Overwriting error handler to ignore User not found message
 * TODO: Review the strategy of handling errors.
 * */
Vue.config.errorHandler = function (err, vm, info) {
  if (err.message !== "User not found.") {
    let dataError = err.response.data.error || null;
    if (
      !dataError.includes("Code required") &&
      !dataError.includes("2FA is enabled")
    ) {
      console.error(`Error: ${err.toString()}\nInfo: ${info}`); // eslint-disable-line no-console
    }
  }
};

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");

/* Warning: hacky fix
 * This attempts to remove a Vuetify stylesheet. This stylesheet is tree-shaken out in production
 * but causes extra padding during development.
 * TODO: get rid of this and find an appropriate way to remove the stylesheeet in question (can this be done in webpack?)
 */
process.env.NODE_ENV !== "production" &&
  document.querySelectorAll("style").forEach((styleBlock) => {
    styleBlock.textContent.includes(
      ".container {\n  width: 100%;\n  padding: 12px;\n  margin-right: auto;\n  margin-left: auto;\n}\n@media (min-width: 960px) {\n  .container {\n    max-width: 900px;\n "
    ) && styleBlock.remove();
  });
